import { styled } from '@/styled-system/jsx';
import { cva } from '@/styled-system/css';

const toggleButtonRecipe = cva({
  base: {
    fontSize: 'sm',
    lineHeight: '1',
    backgroundColor: 'hpxWhite',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'hpxGrey500',
    borderRadius: '4px',
    height: '32px',
    padding: '6px',
    color: 'hpxBlue600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  variants: {
    isPressed: {
      true: {
        fontWeight: 'bold',
        backgroundColor: 'hpxTeal500',
        color: 'hpxWhite',
      },
    },
    toggleGroup: {
      true: {
        flexGrow: '1',
        flexShrink: '1',
        flexBasis: '20%',
        marginRight: 'xs',
        '&:last-child': {
          marginRight: '0',
        },
      },
    },
  },
});

export const ToggleButton = styled('button', toggleButtonRecipe);

export const Icon = styled('img', {
  base: {
    marginRight: '1x',
  },
});

export const TextWrapper = styled('span', {
  base: {
    position: 'relative',
    top: '1px',
  },
});

export const CaratSpan = styled('span', {
  base: {
    paddingLeft: 'xs',
  },
});

export const Carat = styled('img', {
  base: {
    transform: 'rotate(-90deg)',
    '&:active': {
      transform: 'rotate(90deg)',
    },
  },
});
